module.exports = "<button class=\"card p{{i}}\">Position {{piece}}: {{label}}</button>\n";